import clsx from "clsx";
import type { CabinState } from "../../types/domain";

export function AmbientBackdrop({ state }: { state: CabinState }) {
  return (
    <div className={clsx("ambient-backdrop", `ambient-backdrop--${state.weather}`, `ambient-backdrop--${state.desktop}`)}>
      <div className="ambient-backdrop__road" />
      <div className="ambient-backdrop__grid" />
      <div className="ambient-backdrop__scanline" />
    </div>
  );
}
